/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Availability API - .Net 6
 * <b>Build:</b>Radianse.Api.Availability_main_2023.10.30.1
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface IAvailabilityLock
 */
export interface IAvailabilityLock {
  /**
   * id
   * @type {string}
   * @memberof IAvailabilityLock
   */
  id: string;
  /**
   * PartitionKey = tenantId
   * @type {string}
   * @memberof IAvailabilityLock
   */
  partitionKey?: string | null;
  /**
   * Stored with constant category for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IAvailabilityLock
   */
  category?: string;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IAvailabilityLock
   */
  subCategory?: string;
  /**
   * ScheduleId return from TryCreateLock
   * @type {string}
   * @memberof IAvailabilityLock
   */
  scheduleId?: string;
  /**
   * Name Property.
   * @type {string}
   * @memberof IAvailabilityLock
   */
  name: string;
  /**
   * Resources to schedule.
   * @type {Array<IScheduleResourceInfo>}
   * @memberof IAvailabilityLock
   */
  resources?: Array<IScheduleResourceInfo>;
  /**
   * Time to live of the lock. This will auto disappear at ttl.
   * @type {number}
   * @memberof IAvailabilityLock
   */
  ttl?: number | null;
  /**
   * End time as DateTime
   * @type {string}
   * @memberof IAvailabilityLock
   */
  endTime?: string | null;
  /**
   * Start time as DateTime
   * @type {string}
   * @memberof IAvailabilityLock
   */
  startTime?: string;
  /**
   * Location of schedule creation.
   * @type {string}
   * @memberof IAvailabilityLock
   */
  creationLocation: string;
  /**
   * The requirements and token of validated rules requirements.
   * @type {Array<IRulesValidation>}
   * @memberof IAvailabilityLock
   */
  rulesValidations?: Array<IRulesValidation> | null;
  /**
   * @type {IRuleStageType}
   * @memberof IAvailabilityLock
   */
  stage?: IRuleStageType;
}
/**
 *
 * @export
 * @interface IAvailabilityLockIEnumerableIRadianseResult
 */
export interface IAvailabilityLockIEnumerableIRadianseResult {
  /**
   * @type {number}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IAvailabilityLock>}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  data?: Array<IAvailabilityLock> | null;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIEnumerableIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IAvailabilityLockIRadianseResult
 */
export interface IAvailabilityLockIRadianseResult {
  /**
   * @type {number}
   * @memberof IAvailabilityLockIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IAvailabilityLock}
   * @memberof IAvailabilityLockIRadianseResult
   */
  data?: IAvailabilityLock;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IAvailabilityLockIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IAvailabilityLockIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IAvailabilityLockIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IAvailabilityLockIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Times the resource is available
 * @export
 * @interface IAvailabilityTimes
 */
export interface IAvailabilityTimes {
  /**
   * Start time
   * @type {string}
   * @memberof IAvailabilityTimes
   */
  startTime: string;
  /**
   * End time
   * @type {string}
   * @memberof IAvailabilityTimes
   */
  endTime: string;
  /**
   * Is resource available
   * @type {boolean}
   * @memberof IAvailabilityTimes
   */
  isAvailable: boolean;
  /**
   * Resource message if not available
   * @type {Array<IResourceAndIsAvailable>}
   * @memberof IAvailabilityTimes
   */
  resources: Array<IResourceAndIsAvailable>;
}
/**
 *
 * @export
 * @interface IAvailabilityTimesListIRadianseResult
 */
export interface IAvailabilityTimesListIRadianseResult {
  /**
   * @type {number}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IAvailabilityTimes>}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  data?: Array<IAvailabilityTimes> | null;
  /**
   * @type {string}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IAvailabilityTimesListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IBooleanIRadianseResult
 */
export interface IBooleanIRadianseResult {
  /**
   * @type {number}
   * @memberof IBooleanIRadianseResult
   */
  count?: number | null;
  /**
   * @type {boolean}
   * @memberof IBooleanIRadianseResult
   */
  data?: boolean;
  /**
   * @type {string}
   * @memberof IBooleanIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IBooleanIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IBooleanIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IBooleanIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IBooleanIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IBooleanIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IBooleanIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IBooleanIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IBooleanIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IClientTreeType = {
  Customer: "Customer",
  Tenant: "Tenant",
  Group: "Group",
} as const;

export type IClientTreeType =
  typeof IClientTreeType[keyof typeof IClientTreeType];

/**
 * Create a schedule
 * @export
 * @interface ICreateScheduleDto
 */
export interface ICreateScheduleDto {
  /**
   * Schedule ID
   * @type {string}
   * @memberof ICreateScheduleDto
   */
  scheduleId: string;
  /**
   * The requirements and token of validated rules requirements.
   * @type {Array<IRulesValidation>}
   * @memberof ICreateScheduleDto
   */
  rulesValidations?: Array<IRulesValidation> | null;
}
/**
 *
 * @export
 * @interface ICreateScheduleNoLockDto
 */
export interface ICreateScheduleNoLockDto {
  /**
   * Name of the schedule
   * @type {string}
   * @memberof ICreateScheduleNoLockDto
   */
  name: string;
  /**
   * Start time
   * @type {string}
   * @memberof ICreateScheduleNoLockDto
   */
  startTime?: string | null;
  /**
   * End time
   * @type {string}
   * @memberof ICreateScheduleNoLockDto
   */
  endTime?: string | null;
  /**
   * Resources
   * @type {Array<IResourceAndSlot>}
   * @memberof ICreateScheduleNoLockDto
   */
  resources: Array<IResourceAndSlot>;
  /**
   * Location of schedule creation.
   * @type {string}
   * @memberof ICreateScheduleNoLockDto
   */
  creationLocation: string;
  /**
   * The requirements and token of validated rules requirements.
   * @type {Array<IRulesValidation>}
   * @memberof ICreateScheduleNoLockDto
   */
  rulesValidations?: Array<IRulesValidation> | null;
}
/**
 * Class to return events available during a time slot
 * @export
 * @interface IEventsAvailable
 */
export interface IEventsAvailable {
  /**
   * @type {IIdName}
   * @memberof IEventsAvailable
   */
  events?: IIdName;
  /**
   * Indicate if available
   * @type {boolean}
   * @memberof IEventsAvailable
   */
  isAvailable?: boolean;
  /**
   * ElementTreeId
   * @type {string}
   * @memberof IEventsAvailable
   */
  elementTreeId?: string;
}
/**
 *
 * @export
 * @interface IEventsAvailableListIRadianseResult
 */
export interface IEventsAvailableListIRadianseResult {
  /**
   * @type {number}
   * @memberof IEventsAvailableListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IEventsAvailable>}
   * @memberof IEventsAvailableListIRadianseResult
   */
  data?: Array<IEventsAvailable> | null;
  /**
   * @type {string}
   * @memberof IEventsAvailableListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEventsAvailableListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IEventsAvailableListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IEventsAvailableListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IEventsAvailableListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IEventsAvailableListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IEventsAvailableListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IEventsAvailableListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IEventsAvailableListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Get resources by ids
 * @export
 * @interface IGetByResourceIdsDto
 */
export interface IGetByResourceIdsDto {
  /**
   * IDs of the resources to get
   * @type {Array<string>}
   * @memberof IGetByResourceIdsDto
   */
  ids: Array<string>;
}
/**
 * Is resource available
 * @export
 * @interface IGetTimeSlotsAvailable
 */
export interface IGetTimeSlotsAvailable {
  /**
   * Start time
   * @type {string}
   * @memberof IGetTimeSlotsAvailable
   */
  startTime: string;
  /**
   * End time
   * @type {string}
   * @memberof IGetTimeSlotsAvailable
   */
  endTime: string;
  /**
   * Resources
   * @type {Array<IScheduleResourceInfo>}
   * @memberof IGetTimeSlotsAvailable
   */
  resources: Array<IScheduleResourceInfo>;
}
/**
 * Is resource available
 * @export
 * @interface IGetTimeSlotsAvailableAll
 */
export interface IGetTimeSlotsAvailableAll {
  /**
   * Start time
   * @type {string}
   * @memberof IGetTimeSlotsAvailableAll
   */
  startTime: string;
  /**
   * End time
   * @type {string}
   * @memberof IGetTimeSlotsAvailableAll
   */
  endTime: string;
  /**
   * Resources
   * @type {Array<IScheduleResourceInfo>}
   * @memberof IGetTimeSlotsAvailableAll
   */
  resources: Array<IScheduleResourceInfo>;
  /**
   * Optional filter by elementTree contains elementTreeId
   * @type {string}
   * @memberof IGetTimeSlotsAvailableAll
   */
  elementTreeId?: string | null;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IIStartAndEnd
 */
export interface IIStartAndEnd {
  /**
   * Start in ticks
   * @type {number}
   * @memberof IIStartAndEnd
   */
  start?: number;
  /**
   * End in ticks
   * @type {number}
   * @memberof IIStartAndEnd
   */
  end?: number;
  /**
   * Start time in UTC
   * @type {string}
   * @memberof IIStartAndEnd
   */
  startTime?: string;
  /**
   * End time in UTC
   * @type {string}
   * @memberof IIStartAndEnd
   */
  endTime?: string;
}
/**
 *
 * @export
 * @interface IIdName
 */
export interface IIdName {
  /**
   * @type {string}
   * @memberof IIdName
   */
  id?: string;
  /**
   * @type {string}
   * @memberof IIdName
   */
  name?: string;
}
/**
 * Is resource available
 * @export
 * @interface IIsAvailablePostDto
 */
export interface IIsAvailablePostDto {
  /**
   * Start time
   * @type {string}
   * @memberof IIsAvailablePostDto
   */
  start: string;
  /**
   * Duration needed
   * @type {number}
   * @memberof IIsAvailablePostDto
   */
  durationInMinutes?: number;
  /**
   * Resources
   * @type {Array<IResourceAndSlot>}
   * @memberof IIsAvailablePostDto
   */
  resources: Array<IResourceAndSlot>;
}
/**
 *
 * @export
 * @interface ILockPostDto
 */
export interface ILockPostDto {
  /**
   * Name of the schedule
   * @type {string}
   * @memberof ILockPostDto
   */
  name: string;
  /**
   * Start time
   * @type {string}
   * @memberof ILockPostDto
   */
  startTime?: string | null;
  /**
   * End time
   * @type {string}
   * @memberof ILockPostDto
   */
  endTime?: string | null;
  /**
   * Time in seconds to hold the lock while rules are evaluated
   * @type {number}
   * @memberof ILockPostDto
   */
  lockDurationInSeconds: number;
  /**
   * Resources
   * @type {Array<IResourceAndSlot>}
   * @memberof ILockPostDto
   */
  resources: Array<IResourceAndSlot>;
  /**
   * Location of schedule creation.
   * @type {string}
   * @memberof ILockPostDto
   */
  creationLocation: string;
  /**
   * Set to true to run rules
   * @type {boolean}
   * @memberof ILockPostDto
   */
  runRules?: boolean | null;
  /**
   * @type {IRuleStageType}
   * @memberof ILockPostDto
   */
  stage?: IRuleStageType;
}
/**
 *
 * @export
 * @interface IMetaDataInfo
 */
export interface IMetaDataInfo {
  /**
   * @type {any}
   * @memberof IMetaDataInfo
   */
  data?: any;
}
/**
 * Edit an existing schedule
 * @export
 * @interface IPatchScheduleDto
 */
export interface IPatchScheduleDto {
  /**
   * Start time
   * @type {string}
   * @memberof IPatchScheduleDto
   */
  startTime?: string | null;
  /**
   * End time
   * @type {string}
   * @memberof IPatchScheduleDto
   */
  endTime?: string | null;
  /**
   * Set to true to run rules
   * @type {boolean}
   * @memberof IPatchScheduleDto
   */
  runRules?: boolean | null;
}
/**
 *
 * @export
 * @interface IRequestLockResponse
 */
export interface IRequestLockResponse {
  /**
   *
   * @type {string}
   * @memberof IRequestLockResponse
   */
  scheduleId?: string;
  /**
   *
   * @type {Array<IResourceAndIsAvailable>}
   * @memberof IRequestLockResponse
   */
  resourcesAvailability?: Array<IResourceAndIsAvailable>;
  /**
   * @type {IRequirementValidationResult}
   * @memberof IRequestLockResponse
   */
  rules?: IRequirementValidationResult;
}
/**
 *
 * @export
 * @interface IRequestLockResponseIRadianseResult
 */
export interface IRequestLockResponseIRadianseResult {
  /**
   * @type {number}
   * @memberof IRequestLockResponseIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IRequestLockResponse}
   * @memberof IRequestLockResponseIRadianseResult
   */
  data?: IRequestLockResponse;
  /**
   * @type {string}
   * @memberof IRequestLockResponseIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRequestLockResponseIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRequestLockResponseIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRequestLockResponseIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRequestLockResponseIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRequestLockResponseIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRequestLockResponseIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRequestLockResponseIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRequestLockResponseIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IRequirementValidationResult
 */
export interface IRequirementValidationResult {
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  id: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  category?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  subCategory?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  partitionKey: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  evaluatedAtUtc?: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  requirementTypeId: string;
  /**
   * @type {Array<string>}
   * @memberof IRequirementValidationResult
   */
  pendingRules: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IRequirementValidationResult
   */
  ruleFailures: Array<string>;
  /**
   * @type {Array<IRulesExecutionDetail>}
   * @memberof IRequirementValidationResult
   */
  details: Array<IRulesExecutionDetail>;
  /**
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  succeeded?: boolean;
  /**
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  overRideResult?: boolean;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  overRiddenById?: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  overRiddenByName?: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  note?: string;
  /**
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  redeemed?: boolean;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  tenantId: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  customerId: string;
  /**
   * @type {IRuleEvaluatorVm}
   * @memberof IRequirementValidationResult
   */
  request?: IRuleEvaluatorVm;
  /**
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IResourceAndIsAvailable
 */
export interface IResourceAndIsAvailable {
  /**
   *
   * @type {string}
   * @memberof IResourceAndIsAvailable
   */
  id: string;
  /**
   *
   * @type {boolean}
   * @memberof IResourceAndIsAvailable
   */
  isAvailable?: boolean | null;
}
/**
 *
 * @export
 * @interface IResourceAndSlot
 */
export interface IResourceAndSlot {
  /**
   *
   * @type {string}
   * @memberof IResourceAndSlot
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IResourceAndSlot
   */
  partitionKey: string;
  /**
   *
   * @type {string}
   * @memberof IResourceAndSlot
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof IResourceAndSlot
   */
  subCategory: string;
  /**
   *
   * @type {string}
   * @memberof IResourceAndSlot
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof IResourceAndSlot
   */
  slots?: number | null;
}
/**
 *
 * @export
 * @interface IRuleEvaluatorVm
 */
export interface IRuleEvaluatorVm {
  /**
   * @type {Array<IScheduleResourceInfo>}
   * @memberof IRuleEvaluatorVm
   */
  resources: Array<IScheduleResourceInfo>;
  /**
   * @type {string}
   * @memberof IRuleEvaluatorVm
   */
  startTime: string;
  /**
   * @type {number}
   * @memberof IRuleEvaluatorVm
   */
  distance?: number | null;
  /**
   * @type {IRuleStageType}
   * @memberof IRuleEvaluatorVm
   */
  stage?: IRuleStageType;
  /**
   * @type {Array<{ [key: string]: IValidateRulesObj; }>}
   * @memberof IRuleEvaluatorVm
   */
  validateRules?: Array<{ [key: string]: IValidateRulesObj }> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IRuleStageType = {
  Schedule: "Schedule",
  Entry: "Entry",
  Activation: "Activation",
} as const;

export type IRuleStageType = typeof IRuleStageType[keyof typeof IRuleStageType];

/**
 *
 * @export
 * @interface IRulesExecutionDetail
 */
export interface IRulesExecutionDetail {
  /**
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  ruleId?: string;
  /**
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  ruleFailure?: string | null;
  /**
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  handlerId?: string;
  /**
   * @type {boolean}
   * @memberof IRulesExecutionDetail
   */
  isValidated?: boolean;
  /**
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  validationReason?: string;
  /**
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IRulesExecutionDetail
   */
  metaData?: { [key: string]: IMetaDataInfo };
  /**
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  evaluatedAt?: string;
  /**
   * @type {boolean}
   * @memberof IRulesExecutionDetail
   */
  isHandled?: boolean;
}
/**
 *
 * @export
 * @interface IRulesValidation
 */
export interface IRulesValidation {
  /**
   * @type {string}
   * @memberof IRulesValidation
   */
  rulesToken?: string;
  /**
   * @type {string}
   * @memberof IRulesValidation
   */
  requirementTypeId?: string;
}
/**
 *
 * @export
 * @interface IScheduleResourceInfo
 */
export interface IScheduleResourceInfo {
  /**
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  id: string;
  /**
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  partitionKey: string;
  /**
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  category: string;
  /**
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  subCategory: string;
  /**
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  name: string;
}
/**
 *
 * @export
 * @interface IStringIRadianseResult
 */
export interface IStringIRadianseResult {
  /**
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  count?: number | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  data?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IStringIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IStringIStartAndEndListDictionaryIRadianseResult
 */
export interface IStringIStartAndEndListDictionaryIRadianseResult {
  /**
   * @type {number}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  count?: number | null;
  /**
   * @type {{ [key: string]: Array<IIStartAndEnd>; }}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  data?: { [key: string]: Array<IIStartAndEnd> } | null;
  /**
   * @type {string}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IStringIStartAndEndListDictionaryIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IValidateRulesObj
 */
export interface IValidateRulesObj {
  /**
   * @type {string}
   * @memberof IValidateRulesObj
   */
  operatorId?: string | null;
  /**
   * @type {string}
   * @memberof IValidateRulesObj
   */
  operatorPartitionKey?: string;
}

/**
 * AvailabilityApi - axios parameter creator
 * @export
 */
export const AvailabilityApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
     * @summary Get availability
     * @param {IClientTreeType} [requestParameters.clientTreeType] Defaults to Tenant
     * @param {string} [requestParameters.groupId]
     * @param {string} [requestParameters.tenantId]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGet: async (
      clientTreeType?: IClientTreeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Availability`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read
     * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IGetByResourceIdsDto} [requestParameters.iGetByResourceIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGetByResourceIdsPost: async (
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetByResourceIdsDto?: IGetByResourceIdsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Availability/GetByResourceIds`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iGetByResourceIdsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
     * @summary Gets all events that are available for a person
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {boolean} [requestParameters.showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IGetTimeSlotsAvailableAll} [requestParameters.iGetTimeSlotsAvailableAll]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGetEventsAvailablePost: async (
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Availability/GetEventsAvailable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (showIsNotAvailable !== undefined) {
        localVarQueryParameter["showIsNotAvailable"] = showIsNotAvailable;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iGetTimeSlotsAvailableAll,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
     * @summary Get the times an events is available
     * @param {string} requestParameters.id events id
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {boolean} [requestParameters.showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IGetTimeSlotsAvailable} [requestParameters.iGetTimeSlotsAvailable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGetTimeSlotsAvailableIdPost: async (
      id: string,
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiAvailabilityGetTimeSlotsAvailableIdPost",
        "id",
        id
      );
      const localVarPath =
        `/UserApi/Availability/GetTimeSlotsAvailable/{id}`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (showIsNotAvailable !== undefined) {
        localVarQueryParameter["showIsNotAvailable"] = showIsNotAvailable;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iGetTimeSlotsAvailable,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
     * @summary Checks if is available to be scheduled given the input parameters.
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IIsAvailablePostDto} [requestParameters.iIsAvailablePostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityIsAvailablePost: async (
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iIsAvailablePostDto?: IIsAvailablePostDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Availability/IsAvailable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iIsAvailablePostDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_delete
     * @summary Delete a lock
     * @param {string} requestParameters.scheduleId The schedule id
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityScheduleIdDelete: async (
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiAvailabilityScheduleIdDelete",
        "scheduleId",
        scheduleId
      );
      const localVarPath = `/UserApi/Availability/{scheduleId}`.replace(
        `{${"scheduleId"}}`,
        encodeURIComponent(String(scheduleId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read
     * @summary Get availability by scheduleId
     * @param {string} requestParameters.scheduleId
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityScheduleIdGet: async (
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiAvailabilityScheduleIdGet",
        "scheduleId",
        scheduleId
      );
      const localVarPath = `/UserApi/Availability/{scheduleId}`.replace(
        `{${"scheduleId"}}`,
        encodeURIComponent(String(scheduleId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create
     * @summary Create the schedule if the lock still exists.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {ICreateScheduleDto} [requestParameters.iCreateScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilitySchedulePost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCreateScheduleDto?: ICreateScheduleDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Availability/Schedule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iCreateScheduleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create                Rules and availability will need to be rerun
     * @summary Edit an existing schedule
     * @param {string} requestParameters.scheduleId
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IPatchScheduleDto} [requestParameters.iPatchScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityScheduleScheduleIdPatch: async (
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iPatchScheduleDto?: IPatchScheduleDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiAvailabilityScheduleScheduleIdPatch",
        "scheduleId",
        scheduleId
      );
      const localVarPath =
        `/UserApi/Availability/Schedule/{scheduleId}`.replace(
          `{${"scheduleId"}}`,
          encodeURIComponent(String(scheduleId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iPatchScheduleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
     * @summary Create a lock for the resources for the time frame for the specified duration.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {ILockPostDto} [requestParameters.iLockPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityTryCreateLockPost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iLockPostDto?: ILockPostDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Availability/TryCreateLock`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iLockPostDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
     * @summary Create a schedule without a pre existing lock
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {ICreateScheduleNoLockDto} [requestParameters.iCreateScheduleNoLockDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityTryCreatePost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Availability/TryCreate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iCreateScheduleNoLockDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
     * @summary Get availability
     * @param {IClientTreeType} [requestParameters.clientTreeType] Defaults to Tenant
     * @param {string} [requestParameters.groupId]
     * @param {string} [requestParameters.tenantId]
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGet: async (
      clientTreeType?: IClientTreeType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/Availability`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read
     * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IGetByResourceIdsDto} [requestParameters.iGetByResourceIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGetByResourceIdsPost: async (
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      acceptLanguage?: string,
      iGetByResourceIdsDto?: IGetByResourceIdsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/Availability/GetByResourceIds`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iGetByResourceIdsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
     * @summary Gets all events that are available for a person
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {boolean} [requestParameters.showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IGetTimeSlotsAvailableAll} [requestParameters.iGetTimeSlotsAvailableAll]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGetEventsAvailablePost: async (
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/Availability/GetEventsAvailable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (showIsNotAvailable !== undefined) {
        localVarQueryParameter["showIsNotAvailable"] = showIsNotAvailable;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iGetTimeSlotsAvailableAll,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
     * @summary Get the times an events is available
     * @param {string} requestParameters.id events id
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {boolean} [requestParameters.showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IGetTimeSlotsAvailable} [requestParameters.iGetTimeSlotsAvailable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGetTimeSlotsAvailableIdPost: async (
      id: string,
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiV1AvailabilityGetTimeSlotsAvailableIdPost",
        "id",
        id
      );
      const localVarPath =
        `/UserApi/v1/Availability/GetTimeSlotsAvailable/{id}`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (showIsNotAvailable !== undefined) {
        localVarQueryParameter["showIsNotAvailable"] = showIsNotAvailable;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iGetTimeSlotsAvailable,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
     * @summary Checks if is available to be scheduled given the input parameters.
     * @param {IClientTreeType} [requestParameters.clientTreeType]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IIsAvailablePostDto} [requestParameters.iIsAvailablePostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityIsAvailablePost: async (
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      acceptLanguage?: string,
      iIsAvailablePostDto?: IIsAvailablePostDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/Availability/IsAvailable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iIsAvailablePostDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_delete
     * @summary Delete a lock
     * @param {string} requestParameters.scheduleId The schedule id
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityScheduleIdDelete: async (
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiV1AvailabilityScheduleIdDelete",
        "scheduleId",
        scheduleId
      );
      const localVarPath = `/UserApi/v1/Availability/{scheduleId}`.replace(
        `{${"scheduleId"}}`,
        encodeURIComponent(String(scheduleId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_read
     * @summary Get availability by scheduleId
     * @param {string} requestParameters.scheduleId
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityScheduleIdGet: async (
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiV1AvailabilityScheduleIdGet",
        "scheduleId",
        scheduleId
      );
      const localVarPath = `/UserApi/v1/Availability/{scheduleId}`.replace(
        `{${"scheduleId"}}`,
        encodeURIComponent(String(scheduleId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create
     * @summary Create the schedule if the lock still exists.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {ICreateScheduleDto} [requestParameters.iCreateScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilitySchedulePost: async (
      tenantId?: string,
      acceptLanguage?: string,
      iCreateScheduleDto?: ICreateScheduleDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/Availability/Schedule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iCreateScheduleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create                Rules and availability will need to be rerun
     * @summary Edit an existing schedule
     * @param {string} requestParameters.scheduleId
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IPatchScheduleDto} [requestParameters.iPatchScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityScheduleScheduleIdPatch: async (
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      iPatchScheduleDto?: IPatchScheduleDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiV1AvailabilityScheduleScheduleIdPatch",
        "scheduleId",
        scheduleId
      );
      const localVarPath =
        `/UserApi/v1/Availability/Schedule/{scheduleId}`.replace(
          `{${"scheduleId"}}`,
          encodeURIComponent(String(scheduleId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iPatchScheduleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
     * @summary Create a lock for the resources for the time frame for the specified duration.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {ILockPostDto} [requestParameters.iLockPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityTryCreateLockPost: async (
      tenantId?: string,
      acceptLanguage?: string,
      iLockPostDto?: ILockPostDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/Availability/TryCreateLock`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iLockPostDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
     * @summary Create a schedule without a pre existing lock
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.acceptLanguage]
     * @param {ICreateScheduleNoLockDto} [requestParameters.iCreateScheduleNoLockDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityTryCreatePost: async (
      tenantId?: string,
      acceptLanguage?: string,
      iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/Availability/TryCreate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iCreateScheduleNoLockDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AvailabilityApi - functional programming interface
 * @export
 */
export const AvailabilityApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AvailabilityApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
     * Fp
     * @summary Get availability
     * @param {IClientTreeType} [clientTreeType] Defaults to Tenant
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityGet(
      clientTreeType?: IClientTreeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IAvailabilityLockIEnumerableIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityGet(
          clientTreeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read
     * Fp
     * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IGetByResourceIdsDto} [iGetByResourceIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityGetByResourceIdsPost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetByResourceIdsDto?: IGetByResourceIdsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIStartAndEndListDictionaryIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityGetByResourceIdsPost(
          clientTreeType,
          tenantId,
          apiVersion,
          acceptLanguage,
          iGetByResourceIdsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
     * Fp
     * @summary Gets all events that are available for a person
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailableAll} [iGetTimeSlotsAvailableAll]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityGetEventsAvailablePost(
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEventsAvailableListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityGetEventsAvailablePost(
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          apiVersion,
          acceptLanguage,
          iGetTimeSlotsAvailableAll,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
     * Fp
     * @summary Get the times an events is available
     * @param {string} id events id
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailable} [iGetTimeSlotsAvailable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityGetTimeSlotsAvailableIdPost(
      id: string,
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IAvailabilityTimesListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityGetTimeSlotsAvailableIdPost(
          id,
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          apiVersion,
          acceptLanguage,
          iGetTimeSlotsAvailable,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
     * Fp
     * @summary Checks if is available to be scheduled given the input parameters.
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IIsAvailablePostDto} [iIsAvailablePostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityIsAvailablePost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iIsAvailablePostDto?: IIsAvailablePostDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityIsAvailablePost(
          clientTreeType,
          tenantId,
          apiVersion,
          acceptLanguage,
          iIsAvailablePostDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_delete
     * Fp
     * @summary Delete a lock
     * @param {string} scheduleId The schedule id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityScheduleIdDelete(
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IBooleanIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityScheduleIdDelete(
          scheduleId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read
     * Fp
     * @summary Get availability by scheduleId
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityScheduleIdGet(
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IAvailabilityLockIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityScheduleIdGet(
          scheduleId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create
     * Fp
     * @summary Create the schedule if the lock still exists.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleDto} [iCreateScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilitySchedulePost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCreateScheduleDto?: ICreateScheduleDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilitySchedulePost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iCreateScheduleDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create                Rules and availability will need to be rerun
     * Fp
     * @summary Edit an existing schedule
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IPatchScheduleDto} [iPatchScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityScheduleScheduleIdPatch(
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iPatchScheduleDto?: IPatchScheduleDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequestLockResponseIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityScheduleScheduleIdPatch(
          scheduleId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iPatchScheduleDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
     * Fp
     * @summary Create a lock for the resources for the time frame for the specified duration.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ILockPostDto} [iLockPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityTryCreateLockPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iLockPostDto?: ILockPostDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequestLockResponseIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityTryCreateLockPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iLockPostDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
     * Fp
     * @summary Create a schedule without a pre existing lock
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleNoLockDto} [iCreateScheduleNoLockDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiAvailabilityTryCreatePost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequestLockResponseIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiAvailabilityTryCreatePost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iCreateScheduleNoLockDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
     * Fp
     * @summary Get availability
     * @param {IClientTreeType} [clientTreeType] Defaults to Tenant
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityGet(
      clientTreeType?: IClientTreeType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IAvailabilityLockIEnumerableIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityGet(
          clientTreeType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read
     * Fp
     * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IGetByResourceIdsDto} [iGetByResourceIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityGetByResourceIdsPost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      acceptLanguage?: string,
      iGetByResourceIdsDto?: IGetByResourceIdsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIStartAndEndListDictionaryIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityGetByResourceIdsPost(
          clientTreeType,
          tenantId,
          acceptLanguage,
          iGetByResourceIdsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
     * Fp
     * @summary Gets all events that are available for a person
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailableAll} [iGetTimeSlotsAvailableAll]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityGetEventsAvailablePost(
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEventsAvailableListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityGetEventsAvailablePost(
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          acceptLanguage,
          iGetTimeSlotsAvailableAll,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
     * Fp
     * @summary Get the times an events is available
     * @param {string} id events id
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailable} [iGetTimeSlotsAvailable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityGetTimeSlotsAvailableIdPost(
      id: string,
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IAvailabilityTimesListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityGetTimeSlotsAvailableIdPost(
          id,
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          acceptLanguage,
          iGetTimeSlotsAvailable,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
     * Fp
     * @summary Checks if is available to be scheduled given the input parameters.
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IIsAvailablePostDto} [iIsAvailablePostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityIsAvailablePost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      acceptLanguage?: string,
      iIsAvailablePostDto?: IIsAvailablePostDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityIsAvailablePost(
          clientTreeType,
          tenantId,
          acceptLanguage,
          iIsAvailablePostDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_delete
     * Fp
     * @summary Delete a lock
     * @param {string} scheduleId The schedule id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityScheduleIdDelete(
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IBooleanIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityScheduleIdDelete(
          scheduleId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_read
     * Fp
     * @summary Get availability by scheduleId
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityScheduleIdGet(
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IAvailabilityLockIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityScheduleIdGet(
          scheduleId,
          tenantId,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create
     * Fp
     * @summary Create the schedule if the lock still exists.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleDto} [iCreateScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilitySchedulePost(
      tenantId?: string,
      acceptLanguage?: string,
      iCreateScheduleDto?: ICreateScheduleDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilitySchedulePost(
          tenantId,
          acceptLanguage,
          iCreateScheduleDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create                Rules and availability will need to be rerun
     * Fp
     * @summary Edit an existing schedule
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IPatchScheduleDto} [iPatchScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityScheduleScheduleIdPatch(
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      iPatchScheduleDto?: IPatchScheduleDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequestLockResponseIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityScheduleScheduleIdPatch(
          scheduleId,
          tenantId,
          acceptLanguage,
          iPatchScheduleDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
     * Fp
     * @summary Create a lock for the resources for the time frame for the specified duration.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {ILockPostDto} [iLockPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityTryCreateLockPost(
      tenantId?: string,
      acceptLanguage?: string,
      iLockPostDto?: ILockPostDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequestLockResponseIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityTryCreateLockPost(
          tenantId,
          acceptLanguage,
          iLockPostDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
     * Fp
     * @summary Create a schedule without a pre existing lock
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleNoLockDto} [iCreateScheduleNoLockDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1AvailabilityTryCreatePost(
      tenantId?: string,
      acceptLanguage?: string,
      iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequestLockResponseIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1AvailabilityTryCreatePost(
          tenantId,
          acceptLanguage,
          iCreateScheduleNoLockDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * AvailabilityApi - factory interface
 * @export
 */
export const AvailabilityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AvailabilityApiFp(configuration);
  return {
    /**
     * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
     * Factory
     * @summary Get availability
     * @param {IClientTreeType} [clientTreeType] Defaults to Tenant
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGet(
      clientTreeType?: IClientTreeType,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IAvailabilityLockIEnumerableIRadianseResult> {
      return localVarFp
        .userApiAvailabilityGet(
          clientTreeType,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read
     * Factory
     * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IGetByResourceIdsDto} [iGetByResourceIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGetByResourceIdsPost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetByResourceIdsDto?: IGetByResourceIdsDto,
      options?: any
    ): AxiosPromise<IStringIStartAndEndListDictionaryIRadianseResult> {
      return localVarFp
        .userApiAvailabilityGetByResourceIdsPost(
          clientTreeType,
          tenantId,
          apiVersion,
          acceptLanguage,
          iGetByResourceIdsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
     * Factory
     * @summary Gets all events that are available for a person
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailableAll} [iGetTimeSlotsAvailableAll]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGetEventsAvailablePost(
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
      options?: any
    ): AxiosPromise<IEventsAvailableListIRadianseResult> {
      return localVarFp
        .userApiAvailabilityGetEventsAvailablePost(
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          apiVersion,
          acceptLanguage,
          iGetTimeSlotsAvailableAll,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
     * Factory
     * @summary Get the times an events is available
     * @param {string} id events id
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailable} [iGetTimeSlotsAvailable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityGetTimeSlotsAvailableIdPost(
      id: string,
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
      options?: any
    ): AxiosPromise<IAvailabilityTimesListIRadianseResult> {
      return localVarFp
        .userApiAvailabilityGetTimeSlotsAvailableIdPost(
          id,
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          apiVersion,
          acceptLanguage,
          iGetTimeSlotsAvailable,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
     * Factory
     * @summary Checks if is available to be scheduled given the input parameters.
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IIsAvailablePostDto} [iIsAvailablePostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityIsAvailablePost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iIsAvailablePostDto?: IIsAvailablePostDto,
      options?: any
    ): AxiosPromise<boolean> {
      return localVarFp
        .userApiAvailabilityIsAvailablePost(
          clientTreeType,
          tenantId,
          apiVersion,
          acceptLanguage,
          iIsAvailablePostDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_delete
     * Factory
     * @summary Delete a lock
     * @param {string} scheduleId The schedule id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityScheduleIdDelete(
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IBooleanIRadianseResult> {
      return localVarFp
        .userApiAvailabilityScheduleIdDelete(
          scheduleId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read
     * Factory
     * @summary Get availability by scheduleId
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityScheduleIdGet(
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IAvailabilityLockIRadianseResult> {
      return localVarFp
        .userApiAvailabilityScheduleIdGet(
          scheduleId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create
     * Factory
     * @summary Create the schedule if the lock still exists.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleDto} [iCreateScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilitySchedulePost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCreateScheduleDto?: ICreateScheduleDto,
      options?: any
    ): AxiosPromise<IStringIRadianseResult> {
      return localVarFp
        .userApiAvailabilitySchedulePost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iCreateScheduleDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create                Rules and availability will need to be rerun
     * Factory
     * @summary Edit an existing schedule
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IPatchScheduleDto} [iPatchScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityScheduleScheduleIdPatch(
      scheduleId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iPatchScheduleDto?: IPatchScheduleDto,
      options?: any
    ): AxiosPromise<IRequestLockResponseIRadianseResult> {
      return localVarFp
        .userApiAvailabilityScheduleScheduleIdPatch(
          scheduleId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iPatchScheduleDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
     * Factory
     * @summary Create a lock for the resources for the time frame for the specified duration.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ILockPostDto} [iLockPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityTryCreateLockPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iLockPostDto?: ILockPostDto,
      options?: any
    ): AxiosPromise<IRequestLockResponseIRadianseResult> {
      return localVarFp
        .userApiAvailabilityTryCreateLockPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iLockPostDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
     * Factory
     * @summary Create a schedule without a pre existing lock
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleNoLockDto} [iCreateScheduleNoLockDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiAvailabilityTryCreatePost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
      options?: any
    ): AxiosPromise<IRequestLockResponseIRadianseResult> {
      return localVarFp
        .userApiAvailabilityTryCreatePost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iCreateScheduleNoLockDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
     * Factory
     * @summary Get availability
     * @param {IClientTreeType} [clientTreeType] Defaults to Tenant
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGet(
      clientTreeType?: IClientTreeType,
      groupId?: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IAvailabilityLockIEnumerableIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityGet(
          clientTreeType,
          groupId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read
     * Factory
     * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IGetByResourceIdsDto} [iGetByResourceIdsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGetByResourceIdsPost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      acceptLanguage?: string,
      iGetByResourceIdsDto?: IGetByResourceIdsDto,
      options?: any
    ): AxiosPromise<IStringIStartAndEndListDictionaryIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityGetByResourceIdsPost(
          clientTreeType,
          tenantId,
          acceptLanguage,
          iGetByResourceIdsDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
     * Factory
     * @summary Gets all events that are available for a person
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailableAll} [iGetTimeSlotsAvailableAll]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGetEventsAvailablePost(
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
      options?: any
    ): AxiosPromise<IEventsAvailableListIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityGetEventsAvailablePost(
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          acceptLanguage,
          iGetTimeSlotsAvailableAll,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
     * Factory
     * @summary Get the times an events is available
     * @param {string} id events id
     * @param {IClientTreeType} [clientTreeType]
     * @param {boolean} [showIsNotAvailable] If set to true, the time slots that are not available will also be returned.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IGetTimeSlotsAvailable} [iGetTimeSlotsAvailable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityGetTimeSlotsAvailableIdPost(
      id: string,
      clientTreeType?: IClientTreeType,
      showIsNotAvailable?: boolean,
      tenantId?: string,
      acceptLanguage?: string,
      iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
      options?: any
    ): AxiosPromise<IAvailabilityTimesListIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityGetTimeSlotsAvailableIdPost(
          id,
          clientTreeType,
          showIsNotAvailable,
          tenantId,
          acceptLanguage,
          iGetTimeSlotsAvailable,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
     * Factory
     * @summary Checks if is available to be scheduled given the input parameters.
     * @param {IClientTreeType} [clientTreeType]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IIsAvailablePostDto} [iIsAvailablePostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityIsAvailablePost(
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      acceptLanguage?: string,
      iIsAvailablePostDto?: IIsAvailablePostDto,
      options?: any
    ): AxiosPromise<boolean> {
      return localVarFp
        .userApiV1AvailabilityIsAvailablePost(
          clientTreeType,
          tenantId,
          acceptLanguage,
          iIsAvailablePostDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_delete
     * Factory
     * @summary Delete a lock
     * @param {string} scheduleId The schedule id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityScheduleIdDelete(
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IBooleanIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityScheduleIdDelete(
          scheduleId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_read
     * Factory
     * @summary Get availability by scheduleId
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityScheduleIdGet(
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IAvailabilityLockIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityScheduleIdGet(
          scheduleId,
          tenantId,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create
     * Factory
     * @summary Create the schedule if the lock still exists.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleDto} [iCreateScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilitySchedulePost(
      tenantId?: string,
      acceptLanguage?: string,
      iCreateScheduleDto?: ICreateScheduleDto,
      options?: any
    ): AxiosPromise<IStringIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilitySchedulePost(
          tenantId,
          acceptLanguage,
          iCreateScheduleDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create                Rules and availability will need to be rerun
     * Factory
     * @summary Edit an existing schedule
     * @param {string} scheduleId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {IPatchScheduleDto} [iPatchScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityScheduleScheduleIdPatch(
      scheduleId: string,
      tenantId?: string,
      acceptLanguage?: string,
      iPatchScheduleDto?: IPatchScheduleDto,
      options?: any
    ): AxiosPromise<IRequestLockResponseIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityScheduleScheduleIdPatch(
          scheduleId,
          tenantId,
          acceptLanguage,
          iPatchScheduleDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
     * Factory
     * @summary Create a lock for the resources for the time frame for the specified duration.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {ILockPostDto} [iLockPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityTryCreateLockPost(
      tenantId?: string,
      acceptLanguage?: string,
      iLockPostDto?: ILockPostDto,
      options?: any
    ): AxiosPromise<IRequestLockResponseIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityTryCreateLockPost(
          tenantId,
          acceptLanguage,
          iLockPostDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
     * Factory
     * @summary Create a schedule without a pre existing lock
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [acceptLanguage]
     * @param {ICreateScheduleNoLockDto} [iCreateScheduleNoLockDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1AvailabilityTryCreatePost(
      tenantId?: string,
      acceptLanguage?: string,
      iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
      options?: any
    ): AxiosPromise<IRequestLockResponseIRadianseResult> {
      return localVarFp
        .userApiV1AvailabilityTryCreatePost(
          tenantId,
          acceptLanguage,
          iCreateScheduleNoLockDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AvailabilityApi - object-oriented interface
 * @export
 * @class AvailabilityApi
 * @extends {BaseAPI}
 */
export class AvailabilityApi extends BaseAPI {
  /**
   * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
   * --TEST
   * @summary Get availability
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityGet(
    clientTreeType?: IClientTreeType,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityGet(
        clientTreeType,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read
   * --TEST
   * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityGetByResourceIdsPost(
    clientTreeType?: IClientTreeType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iGetByResourceIdsDto?: IGetByResourceIdsDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityGetByResourceIdsPost(
        clientTreeType,
        tenantId,
        apiVersion,
        acceptLanguage,
        iGetByResourceIdsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
   * --TEST
   * @summary Gets all events that are available for a person
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityGetEventsAvailablePost(
    clientTreeType?: IClientTreeType,
    showIsNotAvailable?: boolean,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityGetEventsAvailablePost(
        clientTreeType,
        showIsNotAvailable,
        tenantId,
        apiVersion,
        acceptLanguage,
        iGetTimeSlotsAvailableAll,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
   * --TEST
   * @summary Get the times an events is available
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityGetTimeSlotsAvailableIdPost(
    id: string,
    clientTreeType?: IClientTreeType,
    showIsNotAvailable?: boolean,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityGetTimeSlotsAvailableIdPost(
        id,
        clientTreeType,
        showIsNotAvailable,
        tenantId,
        apiVersion,
        acceptLanguage,
        iGetTimeSlotsAvailable,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
   * --TEST
   * @summary Checks if is available to be scheduled given the input parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityIsAvailablePost(
    clientTreeType?: IClientTreeType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iIsAvailablePostDto?: IIsAvailablePostDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityIsAvailablePost(
        clientTreeType,
        tenantId,
        apiVersion,
        acceptLanguage,
        iIsAvailablePostDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_delete
   * --TEST
   * @summary Delete a lock
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityScheduleIdDelete(
    scheduleId: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityScheduleIdDelete(
        scheduleId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read
   * --TEST
   * @summary Get availability by scheduleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityScheduleIdGet(
    scheduleId: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityScheduleIdGet(
        scheduleId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create
   * --TEST
   * @summary Create the schedule if the lock still exists.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilitySchedulePost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iCreateScheduleDto?: ICreateScheduleDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilitySchedulePost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iCreateScheduleDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create                Rules and availability will need to be rerun
   * --TEST
   * @summary Edit an existing schedule
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityScheduleScheduleIdPatch(
    scheduleId: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iPatchScheduleDto?: IPatchScheduleDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityScheduleScheduleIdPatch(
        scheduleId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iPatchScheduleDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
   * --TEST
   * @summary Create a lock for the resources for the time frame for the specified duration.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityTryCreateLockPost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iLockPostDto?: ILockPostDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityTryCreateLockPost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iLockPostDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
   * --TEST
   * @summary Create a schedule without a pre existing lock
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiAvailabilityTryCreatePost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiAvailabilityTryCreatePost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iCreateScheduleNoLockDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read                Get availability of a resource.  If resource is a person, may want to get there availability per clientTreeType of \"Customer\" since they may have schedules on other tenants.  If resource is a events, that piece of equipment is in a specific tenant\'s place of business, may want to set clientTreeType to \"Tenant\".
   * --TEST
   * @summary Get availability
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityGet(
    clientTreeType?: IClientTreeType,
    groupId?: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityGet(
        clientTreeType,
        groupId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read
   * --TEST
   * @summary Get availability by a set of resource ids. Resource may be equipment.Id, events.Id, member.Id, etc...
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityGetByResourceIdsPost(
    clientTreeType?: IClientTreeType,
    tenantId?: string,
    acceptLanguage?: string,
    iGetByResourceIdsDto?: IGetByResourceIdsDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityGetByResourceIdsPost(
        clientTreeType,
        tenantId,
        acceptLanguage,
        iGetByResourceIdsDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.  If elementTreeId is passed in, returns all events within the elementTreeId and uses less RUs.
   * --TEST
   * @summary Gets all events that are available for a person
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityGetEventsAvailablePost(
    clientTreeType?: IClientTreeType,
    showIsNotAvailable?: boolean,
    tenantId?: string,
    acceptLanguage?: string,
    iGetTimeSlotsAvailableAll?: IGetTimeSlotsAvailableAll,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityGetEventsAvailablePost(
        clientTreeType,
        showIsNotAvailable,
        tenantId,
        acceptLanguage,
        iGetTimeSlotsAvailableAll,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read  If start or end time of slot is within the time requested, the slot will be returned.
   * --TEST
   * @summary Get the times an events is available
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityGetTimeSlotsAvailableIdPost(
    id: string,
    clientTreeType?: IClientTreeType,
    showIsNotAvailable?: boolean,
    tenantId?: string,
    acceptLanguage?: string,
    iGetTimeSlotsAvailable?: IGetTimeSlotsAvailable,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityGetTimeSlotsAvailableIdPost(
        id,
        clientTreeType,
        showIsNotAvailable,
        tenantId,
        acceptLanguage,
        iGetTimeSlotsAvailable,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create                It will only check if it is available without attempting to lock or schedule it. <br></para><b>Id:</b> The unique id assigned to the element you would like to reserve. <para><b>Slots:</b> The number of slots available to schedule. <br></para><b>Start:</b> The UTC start time. <para><b>Duration:</b> The duration needed. <para></para>                If resource is for an events, set the id to events.Id, include slots.  If resource is for equipment, set the id to equipment.id, slots is not needed.  If resource is for member, set the id to member, slots is not needed.
   * --TEST
   * @summary Checks if is available to be scheduled given the input parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityIsAvailablePost(
    clientTreeType?: IClientTreeType,
    tenantId?: string,
    acceptLanguage?: string,
    iIsAvailablePostDto?: IIsAvailablePostDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityIsAvailablePost(
        clientTreeType,
        tenantId,
        acceptLanguage,
        iIsAvailablePostDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_delete
   * --TEST
   * @summary Delete a lock
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityScheduleIdDelete(
    scheduleId: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityScheduleIdDelete(
        scheduleId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_read
   * --TEST
   * @summary Get availability by scheduleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityScheduleIdGet(
    scheduleId: string,
    tenantId?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityScheduleIdGet(
        scheduleId,
        tenantId,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create
   * --TEST
   * @summary Create the schedule if the lock still exists.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilitySchedulePost(
    tenantId?: string,
    acceptLanguage?: string,
    iCreateScheduleDto?: ICreateScheduleDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilitySchedulePost(
        tenantId,
        acceptLanguage,
        iCreateScheduleDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create                Rules and availability will need to be rerun
   * --TEST
   * @summary Edit an existing schedule
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityScheduleScheduleIdPatch(
    scheduleId: string,
    tenantId?: string,
    acceptLanguage?: string,
    iPatchScheduleDto?: IPatchScheduleDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityScheduleScheduleIdPatch(
        scheduleId,
        tenantId,
        acceptLanguage,
        iPatchScheduleDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create                The lock will elapse and the schedule will be released if the lock is not upgraded withing the specified time.                DurationInMinutes: Obsolete parameter, use EndTime instead. BUG 2377 kiosk removed, awaiting 2366 UserStory for UI fix                LockDurationInSeconds: How long to lock the schedule for. Most cases, this would be to set to 20 seconds.                RunRules: If this is true, rules will be run. If rules fails, the lock is removed.
   * --TEST
   * @summary Create a lock for the resources for the time frame for the specified duration.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityTryCreateLockPost(
    tenantId?: string,
    acceptLanguage?: string,
    iLockPostDto?: ILockPostDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityTryCreateLockPost(
        tenantId,
        acceptLanguage,
        iLockPostDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: availability_create <para></para>  If the resource can be scheduled a schedule will be created if not return false
   * --TEST
   * @summary Create a schedule without a pre existing lock
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AvailabilityApi
   */
  public userApiV1AvailabilityTryCreatePost(
    tenantId?: string,
    acceptLanguage?: string,
    iCreateScheduleNoLockDto?: ICreateScheduleNoLockDto,
    options?: AxiosRequestConfig
  ) {
    return AvailabilityApiFp(this.configuration)
      .userApiV1AvailabilityTryCreatePost(
        tenantId,
        acceptLanguage,
        iCreateScheduleNoLockDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet: async (
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/v1/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * Fp
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     *
     * Fp
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiV1RequestContextGet(
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiV1RequestContextGet(
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * Factory
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * Factory
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiV1RequestContextGet(
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiV1RequestContextGet(acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi extends BaseAPI {
  /**
   *
   * --TEST
   * @summary
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiRequestContextGet(
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiRequestContextGet(apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * --TEST
   * @summary
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiV1RequestContextGet(
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiV1RequestContextGet(acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
